<template>
  <modal>
    <div slot="modal-content">
      <div class="start-info">
        <article v-cloak>
          <page-one></page-one>
          <page-two></page-two>
          <page-three></page-three>
          <page-four></page-four>
          <page-five></page-five>
        </article>
        <footer>
          <div class="forward-actions">
            <button
              class="primary next"
              :disabled="isLastStep || disabledForward"
              v-show="!isLastStep"
              @click="skip(1)"
            >
              <i class="ti-arrow-circle-right"></i>
            </button>
            <button
              class="accent save"
              :disabled="!isLastStep"
              v-show="isLastStep"
              @click="createStudyAndScheme"
            >
              <i class="ti-check"></i>
            </button>
          </div>
          <div class="step-dots">
            <div
              class="step-dot"
              :class="{ visited: n <= step, active: n === step }"
              v-for="n in max"
              :key="n"
              @click="goToStep(n)"
            ></div>
          </div>
          <div class="back-actions">
            <button
              class="secondary cancel prev"
              :disabled="isFirstStep"
              v-show="!isFirstStep"
              @click="skip(-1)"
            >
              <i class="ti-arrow-circle-left"></i>
            </button>
          </div>
        </footer>
        <i class="ti-close start-info__close" @click="closeModal"></i>
      </div>
    </div>
  </modal>
</template>
<script>
import Modal from "./CustomModal";
import CreatedTask from "../pages/Notifications/CreateTask";
import { devUrl } from "../settings";
import PageOne from "./OnboardingModal/PageOne";
import PageTwo from "./OnboardingModal/PageTwo";
import PageThree from "./OnboardingModal/PageThree";
import PageFour from "./OnboardingModal/PageFour";
import PageFive from "./OnboardingModal/PageFive";
import axios from "axios";

export default {
  components: {
    Modal,
    PageOne,
    PageTwo,
    PageThree,
    PageFour,
    PageFive
  },
  computed: {
    isFirstStep: function() {
      return this.step === 1;
    },
    isLastStep: function() {
      return this.step === this.max;
    },
    disabledForward() {
      return this.$store.getters.getMovingForward;
    },
    csvError() {
      return this.$store.getters.getCsvError;
    },
    dropedFile() {
      return this.$store.getters.getDroppedFile;
    },
    studyName() {
      return this.$store.getters.getStudyName;
    },
    schemeLabels() {
      return this.$store.getters.getSchemeLabels;
    },
    schemeType() {
      return this.$store.getters.getSchemeType;
    },
    schemeName() {
      return this.$store.getters.getSchemeName;
    },
    schemeDescription() {
      return this.$store.getters.getSchemeDescription;
    }
  },
  data() {
    return {
      step: 1,
      max: 1
    };
  },
  methods: {
    toggleModal: function(step) {
      step = step || 1;
      this.modal.isOpen = !this.modal.isOpen;
      if (this.modal.isOpen) {
        let self = this;
        setTimeout(function() {
          self.$sections = self.$el.querySelectorAll("section");
          self.max = self.$sections.length;
          self.goToStep(step);
        }, 1);
      }
    },
    goToStep: function(step) {
      if (step === 1) {
        this.$store.dispatch("changeForwardState", false);
      } else if (step == 2 && this.dropedFile == null) {
        this.$store.dispatch("changeForwardState", true);
      }
      if (step >= 3 && (this.dropedFile == null || this.csvError !== "")) {
        return;
      }
      if (step == 5 && this.schemeType === "") {
        return;
      }
      if (step == 3 && this.dropedFile) {
        this.$store.dispatch("changeForwardState", false);
      }
      if ((this.step === 4 || step === 4) && this.schemeType === "") {
        this.$store.dispatch("changeForwardState", true);
      }
      this.step = step > this.max ? this.max : step < 1 ? 1 : step;
      this.currentSection = this.$sections[this.step - 1];
      this.currentSection.style.setProperty(
        "--x",
        -(this.step * 100 - 100) + "%"
      );
      this.$sections.forEach(function(section) {
        section.classList.remove("current");
      });
      this.currentSection.classList.add("current");
      this.currentSection.scrollTop = 0;
    },
    skip: function(step) {
      if (step === 1 && this.dropedFile === null) {
        this.$store.dispatch("changeForwardState", true);
      } else if (step === 1 && this.step === 3 && this.schemeType === "") {
        this.$store.dispatch("changeForwardState", true);
      }
      this.step += step;
      this.goToStep(this.step);
    },
    closeModal() {
      this.$store.dispatch("closeLoginModal");
    },

    createStudyAndScheme() {
      let formData = new FormData();
      formData.append("name", this.studyName);
      if (this.dropedFile.type === "url") {
        formData.append("file", this.dropedFile.file);
      } else {
        formData.append("file", this.dropedFile);
      }

      const token = localStorage.getItem("token");

      const config = {
        headers: {
          Authorization: "Token " + token
        }
      };

      axios.post(`${devUrl}studies/`, formData, config).then(createdStudy => {
        let labels = {};

        for (let i = 0; i < this.schemeLabels.length; i++) {
          labels[this.schemeLabels[i].key] = this.schemeLabels[i].value;
        }

        let schemeDescription = labels;

        if (this.schemeType === "form") {
          schemeDescription = {
            name: this.schemeName,
            type: "select",
            choises: this.schemeDescription.split("\n"),
            required: true
          };
        }

        axios
          .post(
            `${devUrl}schemes/`,
            {
              name: this.schemeName,
              description: JSON.stringify(schemeDescription),
              type: this.schemeType
            },
            config
          )
          .then(createdScheme => {
            this.$store.dispatch("postTask", {
              scheme: `${devUrl}schemes/${createdScheme.data.id}/`,
              study: `${devUrl}studies/${createdStudy.data.id}/`
            });
          })
          .then(() => {
            this.$store.dispatch("fetchDatapoints", 1);
            this.closeModal();

            this.$notify({
              component: CreatedTask,
              icon: "ti-gift",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "success"
            });
          });
      });
    }
  },
  created() {
    let self = this;
    setTimeout(function() {
      self.$sections = self.$el.querySelectorAll("section");
      self.max = self.$sections.length;
      self.goToStep(self.step);
    }, 1);
  }
};
</script>
<style lang="scss" scoped>
.start-info {
  width: 600px;
  height: 400px;
  display: flex;
  flex-direction: column;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  position: relative;

  @media only screen and (min-width: 480px) and (max-width: 768px) {
    width: 400px;
    height: 300px;
  }

  @media only screen and (min-width: 320px) and (max-width: 479px) {
    width: 300px;
    height: 300px;
  }

  &__close {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 5px;
    cursor: pointer;
  }
}

article {
  flex: 1 1 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

section {
  width: 100%;
  visibility: hidden;
  flex: 0 0 100%;
  padding: 2em;
  overflow: auto;
  will-change: transform;
  transform: translate(var(--x, 0%), 0%);
  transition: transform 300ms ease-out;
  position: relative;
  h2,
  h3,
  h4 {
    margin-top: 0;
  }
  &.current {
    visibility: visible;
  }
}

footer {
  position: relative;
  text-align: right;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 0 1px rgba(#000, 0.1);
  background: rgba(#000, 0.05);
  padding: 10px;
}

.step-dots {
  display: flex;
  flex-direction: row;
}

.step-dot {
  cursor: pointer;
  width: 1em;
  height: 1em;
  margin: 0.5ch;
  border-radius: 1em;
  border: solid 1px currentColor;
  opacity: 0.2;
  transition: transform 100ms ease-out, opacity 150ms linear;

  &.visited {
    background: currentColor;
  }

  &.active {
    opacity: 0.7;
    box-shadow: 0 0 1em -0.25em;
  }

  &:hover {
    transform: scale(1.2);
  }
}

.forward-actions,
.back-actions {
  flex: 1;
  display: flex;
  flex-direction: row;
}

.forward-actions {
  justify-content: flex-end;
}
.back-actions {
  justify-content: flex-start;
}

button {
  outline: none;
  font: inherit;
  line-height: 1;
  cursor: pointer;
  padding: 0.5em 1em;
  border-radius: 0.35em;
  color: rgba(#000, 0.7);
  background: rgba(#fff, 0.5);
  border: 2px solid rgba(#000, 0.3);
  text-shadow: 0 1px 0 rgba(#fff, 0.4);
  transition: transform 50ms ease-out;
  will-change: transform;

  font-size: 26px;

  &:active {
    transform: scale(0.95);
  }
  &:focus {
    border-color: var(--accent);
    box-shadow: 0 0 1em 0 var(--accent);
  }
  &[disabled] {
    opacity: 0.2;
    cursor: not-allowed;
  }
  &.primary {
    border-color: transparent;
    background: transparent;
    font-weight: bold;
  }
  &.accent {
    &:not([disabled]) {
      color: rgb(48, 182, 55);
      padding: 4px 15px;
    }
  }
  &.secondary {
    border-color: transparent;
    background: transparent;
    &:not([disabled]) {
      color: rgba(#000, 0.4);
    }
  }
  &.cancel:not([disabled]) {
    color: black;
  }
}
</style>
